import { signIn, signOut, getCurrentUser, confirmSignIn } from 'aws-amplify/auth';

export async function isAuthenticated() {
  try { await getCurrentUser(); return true; }
  catch { return false; }
}

export async function login(username, password) {
  return await signIn({ username, password });
  // Returns { isSignedIn, nextStep }
}

export async function confirmNewPassword(newPassword) {
  return await confirmSignIn({ challengeResponse: newPassword });
}

export async function logout() {
  await signOut();
  window.location.href = '/';
}
